import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_moma_2: FaireProductEntity = {
  token: "atc_updated_moma_2",
  type: "product",
  name: "Snoopy & Woodstock Mug",
  brandName: "MoMA Design Store",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/a5e76056339f550390bca3b57d4cc469669ba2f2664b37b4c874a756a0ac57eb.webp",
  priceDollars: 24,
  msrpDollars: 28,
  description: "Peanuts classic design.",
  tags: ["home", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
